<template>
  <div class="scroll-key-frame font-project" >
    <nav class="section-nav" v-if="navList.length > 0"
         :class="[{show: currentSection > 1}, {end: calcScrollEnd === 0}]"
         :style="{ bottom : `${offsetBottom - calcScrollEnd}px`}"
    >
      <div class="section-nav-item" v-for="(nav, index) in navList" :key="nav.title" :class="{current: currentSection === index + 2}">
        <a :href="nav.target" @click.prevent="moveSection(nav.target)">
          {{nav.title}}
        </a>
      </div>
    </nav>
    <div class="font-project section-wrapper" :style="styleWrapper" ref="contents" :class="[stateFrame]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollKeyFrame',
  data() {
    return {
      scrollTop: 0,
      stateFrame: 'ready',
      sectionHeight: 1080,
      offsetBottom: 233,
    };
  },
  props: {
    navList: {
      type: Array,
      default() { return []; },
    },
  },
  computed: {
    styleWrapper() {
      return {
        transform: `translate3d(0, -${this.scrollTop}px, 0)`,
      };
    },
    calcScrollEnd() {
      const calcValue = document.documentElement.scrollHeight - this.wSize.wH - this.scrollTop;
      return calcValue > this.offsetBottom ? this.offsetBottom : calcValue;
    },
    wSize() {
      return { wW: window.innerWidth, wH: window.innerHeight };
    },
    currentSection() {
      return Math.floor(this.scrollTop / this.sectionHeight) + 1;
    },
  },
  mounted() {
    if (this.$route.params.target) {
      this.moveSection(this.$route.params.target);
    }
    document.body.style.height = `${this.$el.parentElement.scrollHeight}px`;
    document.addEventListener('scroll', this.setScrollHandler);
    window.addEventListener('resize', () => {
      document.body.style.height = `${this.$el.parentElement.scrollHeight}px`;
    });
    document.addEventListener('transitionend', () => {
      if (!this.$refs.contents) return;
      this.$refs.contents.style.transition = 'transform 0ms ease';
    });
  },
  destroyed() {
    document.removeEventListener('scroll', this.setScrollHandler);
    document.removeEventListener('transitionend', () => {
      this.$refs.contents.style.transition = 'transform 0ms ease';
    });
  },
  methods: {
    moveSection(target) {
      // const target = e.target.getAttribute('href');
      const section = document.querySelector(target);
      this.$refs.contents.style.transition = 'transform 500ms ease';
      this.scrollTop = section.offsetTop;
      document.documentElement.scrollTop = section.offsetTop;
    },
    setScrollHandler() {
      const keyFrame = document.documentElement.scrollTop;
      this.scrollTop = keyFrame;
      if (keyFrame <= 0) {
        this.stateFrame = 'ready';
      } else {
        this.stateFrame = 'start';
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.section-nav {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9999;
  padding-right: 40px;
  padding-bottom: 40px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  //transition: all 500ms ease;
  opacity: 0;
  &.show {
    opacity: 1;
  }
    .section-nav-item {
        padding: 20px;
        font-size: 22px;
        text-align: right;
        margin-bottom: 14px;
        a {
            border-bottom: 2px solid transparent;
            &:hover {
                font-weight: 600;
                border-bottom: 2px solid #0a0a0a;
            }
        }
        &:last-child {
            margin: 0;
        }
      &.current a{
        font-weight: 600;
        border-bottom: 2px solid #0a0a0a;
      }

    }

}
</style>
